import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"inline-block","margin-right":"10px"} }

import { ref } from 'vue'
import uploadFile from '@/components/ImportBtn/src/uploadFile.vue'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'ImportBtn' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  disabled: {
    type: Boolean,
    default: true
  },
  action: {
    type: String, // 接口地址
    default: ''
  },
  templateUrl: {
    type: String,
    default: ''
  }
},
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n()
const formRef = ref()
const visible = ref(false)
const form = ref<any>({})
const emit = __emit

const toggle = () => {
  visible.value = !visible.value
}
const success = () => {
  visible.value = false
  emit('success')
}

__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = true))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('btn.import')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      title: _unref(t)('btn.import'),
      width: "670px",
      footer: null
    }, {
      default: _withCtx(() => [
        (visible.value)
          ? (_openBlock(), _createBlock(_component_a_form, {
              key: 0,
              model: form.value,
              ref_key: "formRef",
              ref: formRef
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  name: "file",
                  label: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(uploadFile, _mergeProps(_ctx.$attrs, {
                      action: __props.action,
                      templateUrl: __props.templateUrl,
                      onSuccess: success
                    }), null, 16, ["action", "templateUrl"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}
}

})